import { type PropsWithChildren } from 'react'
import { csx } from '@vtex/admin-ui'

import * as styles from './ShortcutBox.styles'

export const ShortcutBox = ({ children }: PropsWithChildren) => (
  <span className={csx(styles.wrapper)}>{children}</span>
)
